import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./Layout.css";

export const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div style={{ fontFamily: "Inter, sans-serif", color: "#333" }}>
      <Helmet>
        {/* Google Analytics (optional) */}
        {process.env.REACT_APP_GA_ID && (
          <>
            <script async src={`https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GA_ID}`}></script>
            <script>
              {`
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);} 
                gtag('js', new Date());
                gtag('config', '${process.env.REACT_APP_GA_ID}', {
                  page_path: window.location.pathname,
                });
              `}
            </script>
          </>
        )}
      </Helmet>

      <nav className="site-topbar">
        <div className="site-topbar-inner">
         <img
         src={`${process.env.PUBLIC_URL}/assets/asdry-black.jpg`}
         alt="ASDRY"
         className="site-logo"
          />
          <button
            className="mobile-menu-toggle"
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            ☰
          </button>

          <div className={`site-nav-links ${menuOpen ? "open" : ""}`}>
            <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
            <Link to="/beta" onClick={() => setMenuOpen(false)}>Beta</Link>
            <Link to="/updates" onClick={() => setMenuOpen(false)}>Updates</Link>
            <Link to="/blog" onClick={() => setMenuOpen(false)}>Field Reports</Link>

            <a
              href="https://asdry.app"
              className="site-nav-cta"
              onClick={() => setMenuOpen(false)}
            >
              Try ASDRY
            </a>
          </div>
        </div>
      </nav>

      <main style={{ maxWidth: 1000, margin: "2rem auto", padding: "0 1rem" }}>
        {children}
      </main>

      <footer
        style={{
          background: "#333",
          color: "white",
          textAlign: "center",
          padding: "1.5rem",
          marginTop: "2rem",
        }}
      >
        <p>
          Forecasts and advice provided by ASDRY are for general informational
          purposes only and should not replace local safety guidance or verified data.
        </p>
        <p>
          <Link to="/terms" style={{ color: "#FFD60A", textDecoration: "none" }}>
            Terms
          </Link>{" "}
          |{" "}
          <Link to="/privacy" style={{ color: "#FFD60A", textDecoration: "none" }}>
            Privacy
          </Link>{" "}
          |{" "}
          <Link to="/cookies" style={{ color: "#FFD60A", textDecoration: "none" }}>
            Cookies
          </Link>
        </p>
        <p style={{ marginTop: "1rem" }}>

  Join the conversation
</p>

<p
  style={{
    display: "flex",
    justifyContent: "center",
    gap: "1rem",
    flexWrap: "wrap"
  }}
>
  <a
    href="https://threads.net/@asdryltd"
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: "#FFD60A", textDecoration: "none" }}
  >
    Threads
  </a>

  <a
    href="https://www.linkedin.com/in/philip-jakeman-0855033b4"
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: "#FFD60A", textDecoration: "none" }}
  >
    LinkedIn
  </a>

  <a
    href="https://instagram.com/asdryltd/"
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: "#FFD60A", textDecoration: "none" }}
  >
    Instagram
  </a>

  <a
    href="https://youtube.com/@asdryltd"
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: "#FFD60A", textDecoration: "none" }}
  >
    YouTube
  </a>
</p>
        <p>
          © {new Date().getFullYear()} ASDRY LTD — ASDRY® is a registered trademark.
          All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default Layout;